import { TextControlProps } from "types";
import TextControl from "../../controls/text-control/text-control";

type RfcCurpControlProps = Omit<TextControlProps, "pattern" | "type" | "maxLength">;

const RfcCurpControl = (props: RfcCurpControlProps) => {
	const rfcFisica = /^(([A-ZÑñ&./-]{4})(\d{6})([A-Z0-9Ññ]{3})?)$/i;
	const rfcMoral = /^(([A-ZÑñ&./-]{3})(\d{6})([A-Z0-9Ññ]{3}))$/i;
	const curp = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/i;

	const extendedProps = {
		...props,
		pattern: {
			value: new RegExp([rfcFisica, rfcMoral, curp].map(regex => regex.source).join("|"), "i"),
			message: "Debes indicar un RFC o CURP válido"
		}
	};

	return (
		<TextControl {...extendedProps} maxLength={18} />
	);
};

export default RfcCurpControl;